import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { PAGES } from '../../Router/pages';
import { RouterContext } from '../../contexts/RouterContext';

import { Container, WrapperFullHeight } from './styles';

const ConclusionImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conclusion.svg';

import Button from '../../components/Button';
import FooterWrapper from '../../components/FooterWrapper';
import { ScheduleContext } from '../../contexts/ScheduleContext';
import { PlatformContext } from '../../contexts/PlatformContext';
import { gtmEvent } from '../../utils/gtm';
import { ModuleContext } from '../../contexts/ModuleContext';
import { Page, Pages, useMainRouter } from '../../Router/pageComponents';

export const AppointmentConclusion = () => {
  const { goTo } = useContextSelector(RouterContext, state => state);
  const { clearData, setIsSchedulerOpen } = useContextSelector(PlatformContext, state => state);
  const { tokenSuccess: token, scheduleItems } = useContextSelector(ScheduleContext, state => state);
  const { selectedItemToSchedule } = useContextSelector(ModuleContext, state => state);

  React.useEffect(() => {
    gtmEvent({
      event: 'agendamento-einstein',
      categoria: scheduleItems[0]?.productName?.includes('gripe') ? 'Agendar-Vacina' : 'Agendar',
      acao: 'step-7',
      rotulo: 'sucesso'
    });
  }, []);

  const { navigate } = useMainRouter();

  return (
    <Container>
      <WrapperFullHeight>
        <img src={ConclusionImg} alt="sucesso" />
        <h1 className="title">Agendamento realizado com sucesso!</h1>
        <p className="subtitle">Para consultar as informações do seu agendamento use o código:</p>
        <p className="code">{token || '000 000'}</p>
      </WrapperFullHeight>
      <FooterWrapper>
        <Button
          title="Ir para home"
          onClick={() => {
            setIsSchedulerOpen(false);
            clearData();
          }}
        />
        <Button
          title="Novo agendamento"
          onClick={() => {
            clearData();
            if (selectedItemToSchedule === 'PRODUCT_ENV') goTo(PAGES.RESOURCE_DETAILS.id, undefined, true);
            if (selectedItemToSchedule === 'SERVICE_ENV') goTo(PAGES.RESOURCE_DETAILS.id, undefined, true);
            if (selectedItemToSchedule === 'PRODUCT') navigate(Page.SERVICE_LIST);
            if (selectedItemToSchedule === 'SPECIALIST') navigate(Page.SERVICE_LIST);
          }}
          tertiary
        />
      </FooterWrapper>
    </Container>
  );
};
